// extracted by mini-css-extract-plugin
export var root = "t_Z";
export var tab = "t_bN";
export var label = "t_bP";
export var content = "t_F";
export var answer = "t_bQ";
export var openedIcon = "t_bR";
export var closedIcon = "t_bS";